<style scoped>
	.sign-btn {
		display: inline-block;
		border-radius: 4px;
		border: 1px solid #000;
		height: 40px;
		width: 40px;
		font-size: 1.8em;
		line-height: 1.4em;
		text-align: center;
		padding: 0;
	}
</style>
<template>
	<div>
		<respond-form v-if="showRespondForm"/>

		<div v-else class="collection with-header mform z-depth-1">
			<header class="collection-header">
				<h5 style="font-size:120%">Откликнуться на вакансию</h5>
				<small>Быстрый отклик и регистрация/авторизация</small>
			</header>
			<div class="collection-item">
<!--
				<div class="col s10 m11 input-field">
					<input id="user_email" name="email" type="email"
						   inputmode="email" autocomplete="username"
						   v-model="user.email">
					<label for="user_email">Email*</label>
				</div>
				<div class="col s2 m1" style="margin-top:25px">
					<button class="btn right" type="button">Next</button>
				</div>
-->

				<div class="col s12 m12" style="margin-left:-12px">
					<p>Или быстрая регистрация/авторизация через OAuth</p>

					<div role="button" class="sign-btn" @click="auth('gmail')">
						<i class="fab fa-google-plus-g"></i>
					</div>
					<div role="button" class="sign-btn" @click="auth('github')">
						<i class="fab fa-github-alt"></i>
					</div>
					<div role="button" class="sign-btn" @click="auth('in')">
						<i class="fab fa-linkedin-in"></i>
					</div>
					<div role="button" class="sign-btn" @click="auth('yandex')">
						<i class="fab fa-yandex"></i>
					</div>
					<div role="button" class="sign-btn" @click="auth('vk')">
						<i class="fab fa-vk"></i>
					</div>
					<div role="button" class="sign-btn" @click="auth('mailru')">
						<i class="fab fa-vk"></i>
					</div>
					<div role="button" class="sign-btn" @click="auth('fb')">
<!--						<i class="fab fa-facebook-f"></i>-->
						<i class="fas fa-sign-in-alt"></i>
					</div>
<!--					<hr>-->
<!--					<button type="button" @click="nextStep1"-->
<!--							class="btn lighten-1 waves-effect" style="margin: 10px 0 20px 0">Далее-->
<!--					</button>-->
					<legal-text-block style="font-size:.8em;line-height:1em" />
					<div style="height:20px"></div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
	import '@/styles/signbtn.css';
	import {catchhandler, send, get} from "@geekjob/lib/http";
	import LegalTextBlock from '@/components/LegalTextBlock.vue';
	import RespondForm from "../App.vue";


	export default {
		components: { RespondForm, LegalTextBlock },
		data() {
			return {
				mainDomain: window.mainDomain,
				company: window.Company,
				anonim: false,
				currentUri: location.href,
				vacancy: window.Vacancy,
				vacancyTitle: window.Vacancy.position,

				text: '',
				loading: false,
				cvList: [],
				user: {
					email: '',
					name: '',
				},

				selectedIndex: 0,
				responded: false,
				show: false,
				oldresponds: 0,

				showRespondForm: false,
			}
		},
		created() {
			const messageListener = event => {
				if (`https://${this.mainDomain}` != event.origin) return;
				if ('auth_success' == event.data) this.showRespondForm = true
			};
			window.addEventListener('message', messageListener);
		},
		methods: {
			auth(type) { this['go2'+type]() },
			go2vk() { window.open(window.$vk_oauth_url, '_blank') },
			go2in() { window.open(window.$linkedin_oauth_url, '_blank') },
			go2fb() { window.open(window.$fb_oauth_url, '_blank') },
			go2gmail() { window.open(window.$google_oauth_url, '_blank') },
			go2github() { window.open(window.$github_oauth_url, '_blank') },
			go2mailru() { window.open(window.$mailru_oauth_url, '_blank') },
			go2yandex() { window.open(window.$yandex_oauth_url, '_blank') },
		},
	}
</script>
